module.exports = __webpack_public_path__ + "img/service-2.24ec1126.png";